import BudgetSummary from "components/main/BudgetSummary";
import Column from "components/Column";
import LowPerformance from "components/suggestions/LowPerformance";
import Opportunity from "components/suggestions/Opportunity";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Row from "components/Row";
import useWindowSize from "../layout/useWindowSize";
import { compose } from "redux";
import withUserPerm from "services/withUserPerm";
import mainSelectors from "modules/main/selectors";
import suggestionAction from "modules/suggestion/actions";
import suggestionSelectors from "modules/suggestion/selectors";
import moment from "moment";

const Suggestions = () => {
  const isMobile = useWindowSize().width < 768;
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const opportunityData = useSelector((state) => suggestionSelectors.opportunityList(state));
  const lowPerformanceData = useSelector((state) => suggestionSelectors.lowPerformanceKeywords(state));
  const dispatch = useDispatch();

  useEffect(() => {
    const cusId = currentAd.ads_account_id;
    const date = moment().format("YYYY-MM-DD");
    dispatch(suggestionAction.GetLowPerformanceKeywords(cusId, date));
    dispatch(suggestionAction.GetOpportunityList(cusId));
  }, [currentAd, dispatch]);

  return (
    <div>
      <BudgetSummary />
      <Row columnSpacing="8px" margin={isMobile ? "0 8px 8px" : "0 0 24px"} responsive>
        {opportunityData.campaigns && opportunityData.campaigns.length ? (
          <>
            <Column>
              <Opportunity data={opportunityData} />
            </Column>
            <Column>
              <LowPerformance data={lowPerformanceData} />
            </Column>
          </>
        ) : (
          <>
            <Column>
              <LowPerformance data={lowPerformanceData} />
            </Column>
            <Column />
          </>
        )}
      </Row>
    </div>
  );
};

export default compose(withUserPerm())(Suggestions);
